export default __webpack_public_path__ + "static/media/main.df05c34e.svg";